// extracted by mini-css-extract-plugin
export default {"container":"vi4Wk","squareImage":"_29tFp","wideImage":"bVjmS"};